var map = {
	"./404.png": 5753,
	"./Contact-first.jpg": 2404,
	"./Contact-second.jpg": 3536,
	"./Home-buffet.jpg": 5347,
	"./Home-entrance.jpg": 5553,
	"./Home-rooms.jpg": 3219,
	"./Menu-icon-b.png": 1837,
	"./Parking-icon.svg": 1859,
	"./WhatsAppButtonGreenLarge.svg": 5649,
	"./about-icon.svg": 3702,
	"./air-conditioning-icon.svg": 8665,
	"./bed-icon.svg": 1284,
	"./bed-three-icon.svg": 3878,
	"./buffet-icon.png": 2199,
	"./calendar-icon.svg": 9955,
	"./description-icon.svg": 6493,
	"./donostia_01.jpg": 6364,
	"./euskady-icon.svg": 8231,
	"./experience-icon.svg": 9889,
	"./gallery-room-Donostia-01.jpg": 2263,
	"./gallery-room-Donostia-02.jpg": 2280,
	"./gallery-room-Donostia-08.jpg": 6754,
	"./gallery-room-Donostia-09.jpg": 8463,
	"./gallery-room-Donostia-10.jpg": 7969,
	"./gallery-room-Donostia-11.jpg": 9924,
	"./gallery-room-Ejecutiva-01.jpg": 7302,
	"./gallery-room-Ejecutiva-02.jpg": 6913,
	"./gallery-room-Ejecutiva-03.jpg": 2516,
	"./gallery-room-Ejecutiva-04.jpg": 5247,
	"./gallery-room-Ejecutiva-05.jpeg": 3487,
	"./gallery-room-Ejecutiva-06.jpg": 7821,
	"./gallery-room-Ejecutiva-07.jpg": 2256,
	"./gallery-room-Ejecutiva-08.jpg": 1387,
	"./gallery-room-Ejecutiva-09.jpg": 78,
	"./gallery-room-Ejecutiva-10.jpg": 820,
	"./gallery-room-Guernica-01.jpg": 2782,
	"./gallery-room-Guernica-02.jpg": 7801,
	"./gallery-room-Guernica-03.jpg": 3452,
	"./gallery-room-Guernica-04.jpg": 7863,
	"./gallery-room-Guernica-05.jpg": 5706,
	"./gallery-room-Guernica-06.jpg": 6197,
	"./gallery-room-Standard-02.jpg": 3930,
	"./gallery-room-Standard-03.jpg": 2935,
	"./gallery-room-Standard-04.jpg": 9148,
	"./gallery-room-Standard-05.jpg": 2873,
	"./gallery-room-Standard-06.jpg": 382,
	"./gallery-room-Standard-07.jpg": 6843,
	"./heat-icon.svg": 6731,
	"./hero-d-1.jpg": 9188,
	"./hero-d-2.jpg": 4467,
	"./hero-d.jpg": 470,
	"./image-hotel-2.png": 9278,
	"./image-hotel.png": 8179,
	"./information-icon.svg": 333,
	"./iso-logo.png": 8820,
	"./location-icon.svg": 930,
	"./logo-facebook.png": 5935,
	"./logo-instagram.png": 6007,
	"./logo-linkedin.png": 6093,
	"./logo-twitter.png": 9078,
	"./logo.png": 1300,
	"./mail icon.svg": 9819,
	"./message sent.png": 5860,
	"./people-icon.svg": 9582,
	"./phone icon.svg": 10,
	"./reservas-icon.svg": 752,
	"./room Ejecutiva-01.jpg": 9198,
	"./room Ejecutiva.jpg": 680,
	"./room Guernica.jpg": 8960,
	"./room Suite Donostia-2.jpg": 7350,
	"./room Suite Donostia.jpg": 1871,
	"./room standart-2.jpg": 9875,
	"./room standart.jpg": 6621,
	"./room-2.jpg": 6333,
	"./room-size-icon.svg": 5876,
	"./rooms-icon.svg": 8983,
	"./tv-icon.svg": 6779,
	"./wifi-icon.png": 8378
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3846;